/**
 * Silly Farm Bundle Calculator
 * Amazon-style "Frequently Bought Together" with Add All to Cart
 */

class BundleCalculator extends HTMLElement {
  constructor() {
    super();
    this.checkboxes = this.querySelectorAll('input[type="checkbox"]');
    this.totalEl = this.querySelector('[data-bundle-total]');
    this.addAllBtn = this.querySelector('[data-bundle-add-all]');
    this.addAllText = this.querySelector('.sf-bundle__add-all-text');
    this.addAllLoading = this.querySelector('.sf-bundle__add-all-loading');

    this.bindEvents();
    this.updateTotal();
  }

  bindEvents() {
    this.checkboxes.forEach(cb => {
      cb.addEventListener('change', () => this.updateTotal());
    });

    if (this.addAllBtn) {
      this.addAllBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.addAllToCart();
      });
    }
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  updateTotal() {
    let total = 0;
    let checkedCount = 0;

    this.checkboxes.forEach(cb => {
      if (cb.checked) {
        total += parseInt(cb.dataset.price, 10) || 0;
        checkedCount++;
      }
    });

    if (this.totalEl) {
      this.totalEl.textContent = this.formatMoney(total);
    }

    // Update button state
    if (this.addAllBtn) {
      this.addAllBtn.disabled = checkedCount === 0;
    }
  }

  async addAllToCart() {
    const items = [];

    this.checkboxes.forEach(cb => {
      if (cb.checked && cb.dataset.variantId) {
        items.push({
          id: parseInt(cb.dataset.variantId, 10),
          quantity: 1
        });
      }
    });

    if (items.length === 0) return;

    // Show loading state
    this.addAllBtn.disabled = true;
    if (this.addAllText) this.addAllText.classList.add('hidden');
    if (this.addAllLoading) this.addAllLoading.classList.remove('hidden');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        throw new Error('Failed to add items to cart');
      }

      // Redirect to cart
      window.location.href = '/cart';

    } catch (error) {
      console.error('Bundle add to cart error:', error);

      // Reset button state
      this.addAllBtn.disabled = false;
      if (this.addAllText) this.addAllText.classList.remove('hidden');
      if (this.addAllLoading) this.addAllLoading.classList.add('hidden');

      // Show error (optional: could add toast notification)
      alert('Sorry, there was an error adding items to your cart. Please try again.');
    }
  }
}

// Register custom element
if (!customElements.get('bundle-calculator')) {
  customElements.define('bundle-calculator', BundleCalculator);
}
